import {TemplateService} from "../../services/TemplateService";
import {Template} from "../../entities/Template";

export class PrintCtrl {
    $scope:any;
    templates:Template[];
    selectedTemplate:Template;
    public static $inject = ['$scope','$uibModalInstance','TemplateService', 'totalCount', 'templateType'];
    constructor($scope:any,
                public modalInstance:angular.ui.bootstrap.IModalServiceInstance,
                public templateService:TemplateService,
                public totalCount: number,
                public templateType: string
    ) {
        this.$scope = $scope;
        $scope.vm = this;
        this.templateService.getAll().then((data) => {
            this.templates = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].templateType == this.templateType)
                    this.templates.push(data[i]);
            }
            if(this.templates.length > 0)
                this.selectedTemplate = this.templates[0];
        });
    }
    ok() {
        this.modalInstance.close(this.selectedTemplate);
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}
